module.exports = __webpack_public_path__ + "static/images/wzry-logo.343afff.png";